import Vue from 'vue'
import VueRouter from 'vue-router'
import cookies from 'js-cookie';
import { SHOWN_MENUS } from '@/constant/menu';
import Home from '../views/Home.vue'

import Undermaintenance from '../views/errors/503.vue'
import NotFound from '../views/errors/404.vue'
import Forbidden from '../views/errors/403.vue'

import Login from '../views/auth/Login.vue'
import ForgotPassword from '../views/auth/ForgotPassword.vue'
import ResetPassword from '../views/auth/ResetPassword.vue'

import EditProfile from '../views/user/EditProfile.vue'
import ChangePassword from '../views/user/ChangePassword.vue'

import AdminIndex from '../views/admin/Index.vue'
import AdminForm from '../views/admin/Form.vue'

import RolePermissionIndex from '../views/role_permission/Index.vue'
import RolePermissionEdit from '../views/role_permission/Edit.vue'

import ContentIndex from '../views/content/Index.vue'
import ContentAdd from '../views/content/Add.vue'

import QuestionnaireIndex from '../views/questionnaire/Index.vue'
import QuestionnaireForm from '../views/questionnaire/Form.vue'

import FlowIndex from '../views/flow/Index.vue'
import FlowForm from '../views/flow/Form.vue'

import ProductIndex from '../views/product/Index.vue'
import ProductForm from '../views/product/Form.vue'

import TreatmentIndex from '../views/treatment/Index.vue'
import TreatmentAdd from '../views/treatment/Add.vue'

import MasterLanding from '../views/discoverypages/MasterLanding.vue'

import AdvisorPage from '../views/discoverypages/advisor-page.vue'

import AboutUs from '../views/discoverypages/about-us.vue'

import BlogPage from '../views/discoverypages/article-page.vue'

import FaqPage from '../views/discoverypages/FaqPage.vue'

import PolyclinicIndex from '../views/discoverypages/polyclinic-library/Index.vue'
import PolyclinicForm from '../views/discoverypages/polyclinic-library/Form.vue'

import ConditionIndex from '../views/discoverypages/condition-library/Index.vue'
import ConditionForm from '../views/discoverypages/condition-library/Form.vue'

import BlogIndex from '../views/discoverypages/article-library/Index.vue'
import BlogForm from '../views/discoverypages/article-library/Form.vue'

import TagIndex from '../views/discoverypages/article-tag/Index.vue'
import TagForm from '../views/discoverypages/article-tag/Form.vue'

import CategoryIndex from '../views/discoverypages/article-category/Index.vue'
import CategoryForm from '../views/discoverypages/article-category/Form.vue'

import DoctorIndex from '../views/discoverypages/medical-advisor-library/Index.vue'
import DoctorForm from '../views/discoverypages/medical-advisor-library/Form.vue'

import SpecialistDoctorIndex from '../views/discoverypages/medical-advisor-expertise/Index.vue'
import SpecialistDoctorForm from '../views/discoverypages/medical-advisor-expertise/Form.vue'

import FaqIndex from '../views/discoverypages/faq-library/Index.vue'
import FaqForm from '../views/discoverypages/faq-library/Form.vue'

import TagFaqIndex from '../views/discoverypages/faq-tag/Index.vue'
import TagFaqForm from '../views/discoverypages/faq-tag/Form.vue'

import CategoryFaqIndex from '../views/discoverypages/faq-category/Index.vue'
import CategoryFaqForm from '../views/discoverypages/faq-category/Form.vue'

import CompanySettingIndex from '../views/discoverypages/company-settings/CompanySetting.vue'

import SpecialProductPageIndex from '../views/discoverypages/special-product-page/Index.vue'
import SpecialProductPageForm from '../views/discoverypages/special-product-page/Form.vue'

import LandingPageForm from '../views/landing/Index.vue'

import RegimenPageIndex from '../views/regimen/Index.vue'
import RegimenPageForm from '../views/regimen/Form.vue'
import MobileHome from '../views/mobileapp/MobileHome.vue'

import SchoolHomepage from '../views/school/homepage/Index.vue'

import SchoolDirectoryList from '../views/school/directory/Index.vue'
import SchoolDirectoryForm from '../views/school/directory/Form.vue'

import SchoolCardList from '../views/school/card/Index.vue'
import SchoolCardForm from '../views/school/card/Form.vue'

import InterimPageIndex from '../views/discoverypages/interim-page/Index.vue'
import InterimPageForm from '../views/discoverypages/interim-page/Form.vue'

import TestimonyLibraryIndex from '../views/discoverypages/testimony-library/Index.vue'
import TestimonyLibraryForm from '../views/discoverypages/testimony-library/Form.vue'

import TestimonyVideoLibraryIndex from '../views/discoverypages/testimony-video-library/Index.vue'
import TestimonyVideoLibraryForm from '../views/discoverypages/testimony-video-library/Form.vue'

import TestimonyPage from '../views/discoverypages/TestimonyPage.vue'

import PromoBannerIndex from '../views/promo/promo-banner/Index.vue';
import PromoBannerForm from '../views/promo/promo-banner/Form.vue';

import PromoPage from '../views/promo/promo-page/Index.vue';

import PromoVoucherIndex from '../views/promo/promo-voucher/Index.vue';
import PromoVoucherForm from '../views/promo/promo-voucher/Form.vue';

import StorePlusPage from '../views/store/StorePlus.vue';
import StoreEssentialsPage from '../views/store/StoreEssentials.vue';

import CareCenterIndex from '../views/care-center/Index.vue';
import CareCenterForm from '../views/care-center/Form.vue';

import ProductReviewIndex from '../views/product-review/Index.vue';

import ClinicTreatmentLibraryIndex from '../views/clinic/treatment-library/Index.vue';
import ClinicTreatmentLibraryForm from '../views/clinic/treatment-library/Form.vue';

import ClinicLandingPage from '../views/clinic/landing-page/Index.vue';

import ClinicTreatmentListPage from '../views/clinic/treatment-list-page/Index.vue';

import ProductVariantsIndex from '../views/product-variants/Index.vue'
import ProductVariantsForm from '../views/product-variants/Form.vue'

import SubscriptionPackagesIndex from '../views/subscription/subscription-packages/Index.vue'
import SubscriptionPackagesForm from '../views/subscription/subscription-packages/Form.vue'

import SubscriptionPage from '../views/subscription/subscription-page/Index.vue';

import ProgramPage from '../views/discoverypages/program-page/Index.vue';

import AddOnsPage from '../views/product-add-ons/Index.vue';

import IncompleteTeleconsultAnswersPage from '../views/tools/incomplete-teleconsult-answers/Index.vue';
import RevertShippingStatusPage from '../views/tools/revert-shipping-status/Index.vue';
import ExpiredPaymentToSuccessPage from '../views/tools/expired-payment-to-success/Index.vue';
import RevertRejectedOrderPage from '../views/tools/revert-rejected-order/Index.vue';
import MarkOrderAsCompletePage from '../views/tools/mark-order-as-complete/Index.vue';
import UpdateUserAddressPage from '../views/tools/update-user-address/Index.vue';

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        component: () => import ('../layouts/Main.vue'),
        children: [
            {
                path: '/',
                name: 'Home',
                component: Home
            },
            {
                path: '/user/edit_profile',
                name: 'EditProfile',
                component: EditProfile,
            },
            {
                path: '/user/change_password',
                name: 'ChangePassword',
                component: ChangePassword,
            },
            {
                path: '/admins',
                name: 'AdminIndex',
                component: AdminIndex,
            },
            {
                path: '/admins/add',
                name: 'AdminFormAdd',
                component: AdminForm,
            },
            {
                path: '/admins/edit/:id',
                name: 'AdminFormEdit',
                component: AdminForm,
            },

            // Role Permission Management
            {
                path: '/role-permissions',
                name: 'RolePermissionIndex',
                component: RolePermissionIndex,
                meta: {
                    pageTitle: 'Role & Permission',
                    icon: 'support_agent'
                }
            },
            {
                path: '/role-permissions/edit/:id',
                name: 'RolePermissionEdit',
                component: RolePermissionEdit,
                meta: {
                    pageTitle: 'Role & Permission / Edit',
                    icon: 'support_agent'
                }
            },
            // Content Management
            {
                path: '/contents',
                name: 'ContentIndex',
                component: ContentIndex,
                meta: {
                    pageTitle: 'Content Management',
                    icon: 'support_agent'
                }
            },
            {
                path: '/contents/add',
                name: 'ContentAdd',
                component: ContentAdd,
                meta: {
                    pageTitle: 'Content Management / Add',
                    icon: 'support_agent'
                }
            },
            {
                path: '/contents/edit/:id',
                name: 'ContentAdd',
                component: ContentAdd,
                meta: {
                    pageTitle: 'Content Management / Edit',
                    icon: 'support_agent'
                }
            },
            // Treatment Management
            {
                path: '/treatments',
                name: 'TreatmentIndex',
                component: TreatmentIndex,
                meta: {
                    pageTitle: 'Treatment Management',
                    icon: 'support_agent'
                }
            },
            {
                path: '/treatments/add',
                name: 'TreatmentAdd',
                component: TreatmentAdd,
                meta: {
                    pageTitle: 'Treatment Management / Add',
                    icon: 'support_agent'
                }
            },
            {
                path: '/treatments/edit/:id',
                name: 'TreatmentAdd',
                component: TreatmentAdd,
                meta: {
                    pageTitle: 'Treatment Management / Edit',
                    icon: 'support_agent'
                }
            },
            {
                path: '/otc-landing-page',
                name: 'LandingPageIndex',
                component: LandingPageForm
            },
            {
                path: '/regimens',
                name: 'RegimenPageIndex',
                component: RegimenPageIndex
            },
            {
                path: '/regimens/add',
                name: 'RegimenPageFormAdd',
                component: RegimenPageForm
            },
            {
                path: '/regimens/edit/:id',
                name: 'RegimenPageFormEdit',
                component: RegimenPageForm
            },
            {
                path: '/school-homepage',
                name: 'SchoolHomePage',
                component: SchoolHomepage
            },
            {
                path: '/school-directory',
                name: 'SchoolDirectoryList',
                component: SchoolDirectoryList
            },
            {
                path: '/school-directory/add',
                name: 'SchoolDirectoryForm',
                component: SchoolDirectoryForm
            },
            {
                path: '/school-directory/edit/:id',
                name: 'SchoolDirectoryForm',
                component: SchoolDirectoryForm
            },
            {
                path: '/school-card',
                name: 'SchoolCardList',
                component: SchoolCardList
            },
            {
                path: '/school-card/add',
                name: 'SchoolCardForm',
                component: SchoolCardForm
            },
            {
                path: '/school-card/edit/:id',
                name: 'SchoolCardForm',
                component: SchoolCardForm
            },
            {
                path: '/customer',
                name: 'CustomerIndex',
                component: Undermaintenance,
            },
            {
                path: '/questionnaire',
                name: 'QuestionnaireIndex',
                component: QuestionnaireIndex,
            },
            {
                path: '/questionnaire/add',
                name: 'QuestionnaireFormAdd',
                component: QuestionnaireForm,
            },
            {
                path: '/questionnaire/edit/:id',
                name: 'QuestionnaireFormEdit',
                component: QuestionnaireForm,
            },
            {
                path: '/flows',
                name: 'FlowIndex',
                component: FlowIndex,
            },
            {
                path: '/flows/add',
                name: 'FlowFormAdd',
                component: FlowForm,
            },
            {
                path: '/flows/edit/:id',
                name: 'FlowFormEdit',
                component: FlowForm,
            },
            {
                path: '/inventories',
                name: 'ProductIndex',
                component: ProductIndex,
            },
            {
                path: '/inventories/add',
                name: 'ProductFormAdd',
                component: ProductForm,
            },
            {
                path: '/inventories/edit/:id',
                name: 'ProductFormEdit',
                component: ProductForm,
            },
            {
                path: '/master-landing-page',
                name: 'MasterLanding',
                component: MasterLanding,
            },
            {
                path: '/advisor-page',
                name: 'AdvisorPage',
                component: AdvisorPage,
            },
            {
                path: '/about-us',
                name: 'AboutUs',
                component: AboutUs,
            },
            {
                path: '/article-page',
                name: 'BlogPage',
                component: BlogPage,
            },
            {
                path: '/faq-page',
                name: 'FaqPage',
                component: FaqPage,
            },
            {
                path: '/article-library',
                name: 'BlogIndex',
                component: BlogIndex,
            },
            {
                path: '/article-library/add',
                name: 'BlogFormAdd',
                component: BlogForm,
            },
            {
                path: '/article-library/edit/:id',
                name: 'BlogFormEdit',
                component: BlogForm,
            },
            {
                path: '/article-tag',
                name: 'TagIndex',
                component: TagIndex,
            },
            {
                path: '/article-tag/add',
                name: 'TagFormAdd',
                component: TagForm,
            },
            {
                path: '/article-tag/edit/:id',
                name: 'TagFormEdit',
                component: TagForm,
            },
            {
                path: '/article-category',
                name: 'CategoryIndex',
                component: CategoryIndex,
            },
            {
                path: '/article-category/add',
                name: 'CategoryFormAdd',
                component: CategoryForm,
            },
            {
                path: '/article-category/edit/:id',
                name: 'CategoryFormEdit',
                component: CategoryForm,
            },
            {
                path: '/condition-library',
                name: 'ConditionIndex',
                component: ConditionIndex,
            },
            {
                path: '/condition-library/add',
                name: 'ConditionFormAdd',
                component: ConditionForm,
            },
            {
                path: '/condition-library/edit/:id',
                name: 'ConditionFormEdit',
                component: ConditionForm,
            },
            {
                path: '/polyclinic-library',
                name: 'PolyclinicIndex',
                component: PolyclinicIndex,
            },
            {
                path: '/polyclinic-library/add',
                name: 'PolyclinicFormAdd',
                component: PolyclinicForm,
            },
            {
                path: '/polyclinic-library/edit/:id',
                name: 'PolyclinicFormEdit',
                component: PolyclinicForm,
            },
            {
                path: '/medical-advisor-library',
                name: 'DoctorIndex',
                component: DoctorIndex,
            },
            {
                path: '/medical-advisor-library/add',
                name: 'DoctorFormAdd',
                component: DoctorForm,
            },
            {
                path: '/medical-advisor-library/edit/:id',
                name: 'DoctorFormEdit',
                component: DoctorForm,
            },
            {
                path: '/medical-advisor-expertise',
                name: 'SpecialistDoctorIndex',
                component: SpecialistDoctorIndex,
            },
            {
                path: '/medical-advisor-expertise/add',
                name: 'SpecialistDoctorFormAdd',
                component: SpecialistDoctorForm,
            },
            {
                path: '/medical-advisor-expertise/edit/:id',
                name: 'SpecialistDoctorFormEdit',
                component: SpecialistDoctorForm,
            },
            {
                path: '/faq-library',
                name: 'FaqIndex',
                component: FaqIndex,
            },
            {
                path: '/faq-library/add',
                name: 'FaqFormAdd',
                component: FaqForm,
            },
            {
                path: '/faq-library/edit/:id',
                name: 'FaqFormEdit',
                component: FaqForm,
            },
            {
                path: '/faq-tag',
                name: 'TagFaqIndex',
                component: TagFaqIndex,
            },
            {
                path: '/faq-tag/add',
                name: 'TagFaqFormAdd',
                component: TagFaqForm,
            },
            {
                path: '/faq-tag/edit/:id',
                name: 'TagFaqFormEdit',
                component: TagFaqForm,
            },
            {
                path: '/faq-category',
                name: 'CategoryFaqIndex',
                component: CategoryFaqIndex,
            },
            {
                path: '/faq-category/add',
                name: 'CategoryFaqFormAdd',
                component: CategoryFaqForm,
            },
            {
                path: '/faq-category/edit/:id',
                name: 'CategoryFaqFormEdit',
                component: CategoryFaqForm,
            },
            {
                path: '/company-settings',
                name: 'CompanySettingIndex',
                component: CompanySettingIndex,
            },
            {
                path: '/special-product-page',
                name: 'SpecialProductPageIndex',
                component: SpecialProductPageIndex,
            },
            {
                path: '/special-product-page/add',
                name: 'SpecialProductPageFormAdd',
                component: SpecialProductPageForm,
            },
            {
                path: '/special-product-page/edit/:id',
                name: 'SpecialProductPageFormEdit',
                component: SpecialProductPageForm,
            },
            {
                path: '/interim-page',
                name: 'InterimPageIndex',
                component: InterimPageIndex,
            },
            {
                path: '/interim-page/add',
                name: 'InterimPageFormAdd',
                component: InterimPageForm,
            },
            {
                path: '/interim-page/edit/:id',
                name: 'InterimPageFormFormEdit',
                component: InterimPageForm,
            },
            {
                path: '/testimony-library',
                name: 'TestimonyLibraryPageIndex',
                component: TestimonyLibraryIndex,
            },
            {
                path: '/testimony-library/add',
                name: 'TestimonyLibraryPageFormAdd',
                component: TestimonyLibraryForm,
            },
            {
                path: '/testimony-library/edit/:id',
                name: 'TestimonyLibraryPageFormEdit',
                component: TestimonyLibraryForm,
            },
            {
                path: '/testimony-video-library',
                name: 'TestimonyVideoLibraryPageIndex',
                component: TestimonyVideoLibraryIndex,
            },
            {
                path: '/testimony-video-library/add',
                name: 'TestimonyVideoLibraryPageFormAdd',
                component: TestimonyVideoLibraryForm,
            },
            {
                path: '/testimony-video-library/edit/:id',
                name: 'TestimonyVideoLibraryPageFormEdit',
                component: TestimonyVideoLibraryForm,
            },
            {
                path: '/testimony-page',
                name: 'TestimonyPage',
                component: TestimonyPage,
            },
            {
                path: '/mobile-home',
                name: 'MobileHome',
                component: MobileHome,
            },
            {
                path: '/promotion-detail-pages',
                name: 'PromotionBannerPageIndex',
                component: PromoBannerIndex,
            },
            {
                path: '/promotion-detail-pages/add',
                name: 'PromotionBannerPageFormAdd',
                component: PromoBannerForm,
            },
            {
                path: '/promotion-detail-pages/edit/:id',
                name: 'PromotionBannerPageFormEdit',
                component: PromoBannerForm,
            },
            {
                path: '/promotion-homepage',
                name: 'PromotionPage',
                component: PromoPage,
            },
            {
                path: '/promotion-codes',
                name: 'PromotionVoucherPageIndex',
                component: PromoVoucherIndex,
            },
            {
                path: '/promotion-codes/add',
                name: 'PromotionVoucherPageFormAdd',
                component: PromoVoucherForm,
            },
            {
                path: '/promotion-codes/edit/:id',
                name: 'PromotionVoucherPageFormEdit',
                component: PromoVoucherForm,
            },
            {
                path: '/store-diriplus',
                name: 'StorePlusPage',
                component: StorePlusPage,
            },
            {
                path: '/store-diriessentials',
                name: 'StoreEssentialsPage',
                component: StoreEssentialsPage,
            },
            {
                path: '/care-center',
                name: 'CareCenterPageIndex',
                component: CareCenterIndex,
            },
            {
                path: '/care-center/edit/:id',
                name: 'CareCenterPageFormEdit',
                component: CareCenterForm,
            },
            {
                path: '/product-review',
                name: 'ProductReview',
                component: ProductReviewIndex,
            },
            {
                path: '/clinic-treatment-library',
                name: 'ClinicTreatmentLibrary',
                component: ClinicTreatmentLibraryIndex,
            },
            {
                path: '/clinic-treatment-library/add',
                name: 'ClinicTreatmentLibraryFormAdd',
                component: ClinicTreatmentLibraryForm,
            },
            {
                path: '/clinic-treatment-library/edit/:id',
                name: 'ClinicTreatmentLibraryFormEdit',
                component: ClinicTreatmentLibraryForm,
            },
            {
                path: '/clinic-landing-page',
                name: 'ClinicLandingPage',
                component: ClinicLandingPage,
            },
            {
                path: '/clinic-treatment-list-page',
                name: 'ClinicTreatmentListPage',
                component: ClinicTreatmentListPage,
            },
            {
                path: '/product-variants',
                name: 'ProductVariantsIndex',
                component: ProductVariantsIndex,
            },
            {
                path: '/product-variants/add',
                name: 'ProductVariantsFormAdd',
                component: ProductVariantsForm,
            },
            {
                path: '/product-variants/edit/:id',
                name: 'ProductVariantsFormEdit',
                component: ProductVariantsForm,
            },
            {
                path: '/subscription-packages',
                name: 'SubscriptionPackagesIndex',
                component: SubscriptionPackagesIndex,
            },
            {
                path: '/subscription-packages/add',
                name: 'SubscriptionPackagesFormAdd',
                component: SubscriptionPackagesForm,
            },
            {
                path: '/subscription-packages/edit/:id',
                name: 'SubscriptionPackagesFormEdit',
                component: SubscriptionPackagesForm,
            },
            {
                path: '/subscription-page',
                name: 'SubscriptionPage',
                component: SubscriptionPage,
            },
            {
                path: '/program-page',
                name: 'ProgramPage',
                component: ProgramPage,
            },
            {
                path: '/add-ons',
                name: 'AddOnsPage',
                component: AddOnsPage,
            },
            {
                path: '/incomplete-teleconsult-answers',
                name: 'IncompleteTeleconsultAnswersPage',
                component: IncompleteTeleconsultAnswersPage,
            },
            {
                path: '/revert-shipping-status',
                name: 'RevertShippingStatusPage',
                component: RevertShippingStatusPage,
            },
            {
                path: '/expired-payment-to-success',
                name: 'ExpiredPaymentToSuccessPage',
                component: ExpiredPaymentToSuccessPage,
            },
            {
                path: '/revert-rejected-order',
                name: 'RevertRejectedOrderPage',
                component: RevertRejectedOrderPage,
            },
            {
                path: '/mark-order-as-complete',
                name: 'MarkOrderAsCompletePage',
                component: MarkOrderAsCompletePage,
            },
            {
                path: '/update-user-address',
                name: 'UpdateUserAddressPage',
                component: UpdateUserAddressPage,
            },
            {
                path: '/403',
                name: 'Forbidden',
                component: Forbidden
            },
        ]
    },
    {
        path: '',
        component: () => import ('../layouts/FullPage.vue'),
        children: [
            {
                path: '/login',
                name: 'Login',
                component: Login,
                meta: {
                    isGuest: true
                }
            },
            {
                path: '/forgot-password',
                name: 'ForgotPassword',
                component: ForgotPassword,
                meta: {
                    isGuest: true
                }
            },
            {
                path: '/reset-password',
                name: 'ResetPassword',
                component: ResetPassword,
                meta: {
                    isGuest: true
                }
            },
            {
                path: '*',
                name: 'NotFound',
                component: NotFound
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if ( to.meta.isGuest ) {
        next()
    } else if (!cookies.get('accessTokenV1') ) {
        next({name: 'Login'})
    } else if ( to.path == '/' ) {
        let data = JSON.parse(localStorage.getItem('account'));
        if (data) {
            const filteredMenus = data.admin.role.menus
                .filter(menu => SHOWN_MENUS.includes(menu.link))
                .map(menu => ({
                    ...menu,
                    children: menu.children.filter(child => SHOWN_MENUS.includes(child.link))
                }));
            if (filteredMenus.length > 0) {
                if(filteredMenus[0].children?.length > 0){
                    next({ path: filteredMenus[0].children[0].link });
                } else {
                    next({ path: filteredMenus[0].link });
                }
            } else {
                next({ name: 'Login' });
            }
        } else {
            next({ name: 'Login' });
        }
    }else {
        next()
    }
})

export default router
